/**
 * Created by Owner on 2016/8/9.
 */
import { Component } from '@angular/core';
import { NavController, AlertController, ViewController, LoadingController, App } from 'ionic-angular';
import { LotteryService } from '../../services/lottery.services';
import { LotteryPage } from '../lottery/lottery';
import { AppConfigService } from '../../services/appConfig.service';
import { BetDetailsPage } from '../betDetails/betDetails';
import { SixMarkService } from '../../services/sixmark.services';
import { TaixiuServices } from '../../services/taixiu.services';

@Component({
    templateUrl: 'lotteryHistory.html',
    selector: 'lottery-history-page',
})
export class LotteryHistoryPage {
    recordList: any = [];
    infiniteScrollBoolean: boolean = true;
    totalNum: number = 0;
    // Show total bet & win money
    tamount: any;
    twin: any;

    // arrMMCGameID = [50, 100, 101, 102, 103, 104, 60, 80, 90, 91, 202, 302, 402];
    arrMMCGameID = [50,100, 101, 102, 103, 104,60, 80, 90, , 91, 93, 202, 300,301,302,303,304,305, 400,401,402];

    isMMC: boolean = false;
    isMMC1Giay: boolean = false;
    gameId: any;

    constructor(
        private nav: NavController,
        private app: App,
        private alertCtrl: AlertController,
        private sixMarkService: SixMarkService,
        private lotteryService: LotteryService,
        public viewCtrl: ViewController,
        private taixiuService: TaixiuServices,
        private loadingCtrl: LoadingController
    ) {}

    goDetail(index: number) {
        this.nav.push(BetDetailsPage, {
            betId: index,
        });
    }

    doRefresh(refresher) {
        if (LotteryPage.isSMorTD) {
            this.getFirstDataSM();
        } else {
            this.getFirstData(refresher);
        }
    }

    /*
     * getFirstDataSM for sixmark
     */
    getFirstDataSM(refresher: any = null) {
        let dataParams = {
            lotteryid: LotteryPage.lotteryId,
        };

        this.sixMarkService.lotteryRecordBeanSM(dataParams, this.alertCtrl).then((response) => {
            if (response['status'] == 'success') {
                this.recordList = response['data'][0]['reslist'];
                this.totalNum = response['data']['totalrecord'];
                if (refresher) {
                    refresher.complete();
                    this.infiniteScrollBoolean = true;
                }
            }
        });
    }

    getFirstData(refresher: any = null) {
        this.checkMMCGame(Number(LotteryPage.lotteryId));
        if (Number(LotteryPage.lotteryId) === 80) {
            // is taixiu 1phut
            let dataParams = { sid: LotteryPage.lotteryId };
            this.taixiuService.mDiceHistory(dataParams, this).then((data) => {
                if (data['status'] === 'success') {
                    let getData = data['data'];
                    let totalMoneyBet = 0;
                    let totalMoneyWin = 0;
                    this.recordList = getData.reslist;
                    this.recordList.map((item) => {
                        item['bettime'] = item['bettime'].replace(/-/g, '/');
                        totalMoneyBet += item['amount'];
                        totalMoneyWin += item['bonus'];
                        return item;
                    });
                    this.totalNum = getData.reslist.length;
                    this.tamount = totalMoneyBet;
                    this.twin = totalMoneyWin;
                    if (refresher) {
                        refresher.complete();
                        this.infiniteScrollBoolean = true;
                    }
                }
            });
        } else {
            let dataParams = { lotteryid: LotteryPage.lotteryId };
            this.lotteryService.lotteryRecordBean(dataParams, this).then((data) => {
                if (!data['msg']) {
                    this.recordList = data['reslist'];
                    if (this.isMMC1Giay) {
                        this.recordList.map((item) => {
                            item['issue'] = item['finishtime'].replace(/-/g, '/').substr(11);
                            return item;
                        });
                    }
                    this.recordList.map((item) => {
                        item['bettime'] = item['bettime'].replace(/-/g, '/');
                        return item;
                    });
                    this.totalNum = data['totalrecord'];
                    this.tamount = data['tamount'];
                    this.twin = data['twin'];
                    if (refresher) {
                        refresher.complete();
                        this.infiniteScrollBoolean = true;
                    }
                }
            });
        }
    }

    doInfinite(infiniteScroll) {
        let dataParams = { lotteryid: LotteryPage.lotteryId };
        this.checkMMCGame(Number(dataParams['lotteryid']));
        infiniteScroll.enable(true);
        setTimeout(() => {
            this.lotteryService.lotteryNextRecordBean(dataParams, this).then((data) => {
                if (!data['msg']) {
                    this.recordList = this.recordList.concat(data['reslist']);
                    if (this.isMMC1Giay) {
                        this.recordList.map((item) => {
                            item['issue'] = item['finishtime'].substr(11);
                            return item;
                        });
                    }
                    this.recordList.map((item) => {
                        item['bettime'] = item['bettime'].replace(/-/g, '/');
                        return item;
                    });
                    this.totalNum = data['totalrecord'];
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }

    ionViewWillEnter() {
        this.gameId = LotteryPage.lotteryId;
        if (LotteryPage.isSMorTD) {
            this.getFirstDataSM();
        } else {
            this.getFirstData();
        }
    }

    dismiss() {
        this.viewCtrl.getNav().parent.parent.pop();
        
    }

    checkMMCGame(lotteryID: number) {
        if (lotteryID === 50 || lotteryID === 60 || lotteryID === 90 || lotteryID === 91) {
            this.isMMC1Giay = true;
        }
        if (this.arrMMCGameID.indexOf(lotteryID) > -1) {
            this.isMMC = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/lotteryHistory/lotteryHistory.ts